import { LoadBalancer, ResponseHandler, FetchMiddleware } from '../types';
import { loadBalancers } from '../constants';
import { getPortalId } from './portalId';
import {
  createAppLoginUrl,
  createInternalLoginUrl,
  redirectTo,
} from './util/location';
import { clearHsLocale } from 'hs-locale-management';

export function redirectOn<Arg extends any, C = {}>(
  predicate: (arg: Arg, context?: C) => boolean,
  redirectLocation: string
) {
  return (arg: Arg, context?: C) => {
    if (predicate(arg, context)) {
      redirectTo(redirectLocation);
      return arg;
    }
    return arg;
  };
}

export const logoutOn401: ResponseHandler<{
  loadBalancer: LoadBalancer;
  location: Location;
}> = (response, context) => {
  if (response.status === 401) {
    const isAppAuth = context.loadBalancer === loadBalancers.APP;
    const shouldRedirect =
      !isAppAuth || response.headers.get('x-hubspot-auth-failure') !== null;

    if (shouldRedirect) {
      const loginUrl = isAppAuth
        ? createAppLoginUrl(context.location)
        : createInternalLoginUrl(context.loadBalancer, context.location);
      clearHsLocale();
      redirectTo(loginUrl);
    }
  }
  return response;
};

export const logoutOnMissingPortalId: FetchMiddleware<{
  loadBalancer: LoadBalancer;
  location: Location;
}> = (params, context) => {
  // Only check for APP load balancer, as portal ID is required for app auth
  if (context.loadBalancer !== 'app') {
    return params;
  }

  const portalId = (window as any).hubspot?.portal?.id || getPortalId();

  if (portalId === undefined || portalId === null) {
    clearHsLocale();
    redirectTo(createAppLoginUrl(context.location));
  }

  return params;
};
